/**
 * Storiz — Destination Inputs v3 (assets/destination-selector.js)
 *
 * Simple show/hide logic for the free-text destination groups.
 * No dropdown, no search, no metaobject data required.
 *
 * Group IDs:  #mp-dest-group-1  (always visible)
 *             #mp-dest-group-2  (duo + trio)
 *             #mp-dest-group-3  (trio only)
 *
 * Input IDs:  #mp-dest-name-N  (destination text)
 *             #mp-dest-year-N  (year text)
 *
 * Reacts to:
 *   - CustomEvent 'storiz:bundle:changed' (fired by main-product.liquid offer cards)
 *   - input[name="mp_bundle"] change events (fallback)
 */

'use strict';

(function () {

  document.addEventListener('DOMContentLoaded', function () {

    var BUNDLE_SLOT_COUNT = { solo: 1, duo: 2, trio: 3 };

    /* Show/hide groups and clear hidden ones */
    function updateGroupCount(bundle) {
      var count = BUNDLE_SLOT_COUNT[bundle] || 1;

      for (var i = 1; i <= 3; i++) {
        var group     = document.getElementById('mp-dest-group-' + i);
        var nameInput = document.getElementById('mp-dest-name-' + i);
        var yearInput = document.getElementById('mp-dest-year-' + i);

        if (!group) continue;

        if (i <= count) {
          group.removeAttribute('hidden');
        } else {
          group.setAttribute('hidden', '');
          /* Clear data for hidden groups so stale values aren't submitted */
          if (nameInput) nameInput.value = '';
          if (yearInput) yearInput.value = '';
        }
      }
    }

    /* Listen to bundle:changed event fired by main-product.liquid offer cards */
    document.addEventListener('storiz:bundle:changed', function (e) {
      if (e.detail && e.detail.bundle) updateGroupCount(e.detail.bundle);
    });

    /* Also watch the hidden radio inputs directly (robustness) */
    document.querySelectorAll('input[name="mp_bundle"]').forEach(function (radio) {
      radio.addEventListener('change', function () { updateGroupCount(this.value); });
    });

    /* Initialise on page load */
    var initRadio = document.querySelector('input[name="mp_bundle"]:checked');
    updateGroupCount(initRadio ? initRadio.value : 'solo');

  });

}());
